import { Checkbox, Tooltip } from "@mui/material";
import "./dataMapTable.scss";

const isDisabled = (parameterData, role) => {
  if (role === "investigatorValidatior") {
    if (parameterData?.investigatorValidatiorRowRejection?.isRejected) {
      return true;
    }

    return parameterData?.mappings?.some(
      (ele) => ele?.investigatorValidatiorCellRejection?.isRejected
    );
  }

  if (role === "investigatorMappingValidatior") {
    if (parameterData?.investigatorMappingValidatiorRowRejection?.isRejected) {
      return true;
    }

    return parameterData?.mappings?.some(
      (ele) => ele?.investigatorMappingValidatiorCellRejection?.isRejected
    );
  }

  return false;
};

const ValidationButton = ({
  onClickValidate,
  parameterData,
  parameterIndex,
  role,
  forValue
}) => {
  let isValidated = false;
  let validatedDate = "";

  if (role === "investigatorValidatior") {
    isValidated =
      parameterData?.rowValidationByInvestigatorValidator
        ?.isInvestigatorValidated;
    validatedDate = parameterData?.rowValidationByInvestigatorValidator?.date;
  }

  if (role === "investigatorMappingValidatior") {
    isValidated =
      parameterData?.rowValidationByInvestigatorMappingValidator
        ?.isInvestigatorMappingValidated;
    validatedDate =
      parameterData?.rowValidationByInvestigatorMappingValidator?.date;
  }

  return (
    <div className="sub-row validator">
      {isValidated ? (
        <Tooltip
          arrow
          title={`Validated On : ${validatedDate}`}
          placement="top"
        >
          <Checkbox
            checked
            onChange={() => onClickValidate("invalidate", parameterIndex)}
            size="small"
            sx={{
              "&.Mui-checked": {
                color: "#4caf50 !important",
              },
            }}
            disabled={forValue === "viewOnly"}
          />
        </Tooltip>
      ) : (
        <div className="checkbox-wrap">
          <Checkbox
            onChange={() => onClickValidate("validate", parameterIndex)}
            disabled={isDisabled(parameterData, role) || forValue === "viewOnly"}
            size="small"

          />
        </div>
      )}
    </div>
  );
};

export default ValidationButton;
